

export default function QuizMarking({ quizMark }) {
    const { totalQuiz, totalCorrect, totalWrong, totalMark, mark } = quizMark || {};
    // decide total mark text color 
    const totalMarkColor = ((totalCorrect / totalQuiz) * 100) < 50 ? "text-red-600" : "text-green-600"
    return (

        <div className='w-full border-t border-[#475569] text-center pt-3 mt-3'>
            <div className="text-xl font-bold">Total Mark - <span className="text-2xl"><span className={totalMarkColor}>{mark}</span>/{totalMark}</span></div>
            <div className="mt-2 flex justify-center gap-3 font-semibold">
                <div>
                    <p className="text-green-600">{totalCorrect}</p>
                    <p>Correct Answer</p>
                </div>
                <div>
                    <p className={totalWrong && `text-red-600`}>{totalWrong}</p>
                    <p>Wrong Answer</p>
                </div>
                <div>
                    <p>{totalQuiz}</p>
                    <p>Total Question</p>
                </div>

            </div>
            <div className="p-4 mt-5 text-xl font-semibold text-green-600">Answer Sheet</div>
        </div>

    )
};